import React from "react";
import ReactDOM from "react-dom/client";
import "flag-icons/css/flag-icons.min.css";
import "./styles/checkout-tokens.css";
import "./styles/checkout.css";
import "./styles/facial-capture.css";
import "./styles/facial-validation-layout.css";
import "./styles/immersion-choice.css";
import "./styles/personal-data-step.css";
import "./styles/editorial-checkout-theme.css";
import "./styles/contextual-guidance.css";
import "./styles/facial-checkout-shell.css";
import "./styles/admin-chat.css";
import "./styles/premium-chat-command-center.css";
import "./styles/mobile-identity-validation.css";
import "./styles/mobile-checkout.css";
import "./styles/contract-step-mobile.css";
import "./styles/stability-fixes.css";
import "./styles/premium-chat-approved.css";
import "./styles/premium-chat-geometry-proof.css";
import "./styles/premium-chat-material.css";
import "./styles/premium-chat-optics.css";
import "./styles/premium-chat-book-menu.css";
import "./styles/premium-chat-global-home.css";
import "./styles/payment-step-mobile.css";
import "./styles/responsive-edge-corrections.css";
import "./styles/mobile-language-switcher.css";
import "./styles/desktop-layout-recovery.css";
import "./styles/mobile-repair-336.css";
import "./styles/payment-responsive-final.css";
import "./styles/checkout-completion342.css";
import "./styles/contract-existing-profile344.css";
import "./styles/two-card-recovery343.css";
import "./styles/contract-header344.css";
import "./styles/payment-scrollbar346.css";
import "./styles/payment-feedback352.css";
import "./styles/payment-link-facial-desktop.css";
import "./styles/checkout-blockers20261028.css";
import "./styles/mobile-input-viewport20261031.css";

const isAdminChatRoute = window.location.pathname.startsWith("/admin/chat")
  || new URLSearchParams(window.location.search).has("qa-admin-chat");
const isMobileIdentityRoute = window.location.pathname.startsWith("/validacao-identidade/mobile");
const isMobileCheckoutIdentityRoute = window.location.pathname.startsWith("/checkout/mobile/validacao-facial");

async function mountApplication() {
  const Application = isAdminChatRoute
    ? (await import("./PremiumAdminChatApp")).PremiumAdminChatApp
    : isMobileCheckoutIdentityRoute
      ? (await import("./App")).MobileCheckoutIdentityApp
      : isMobileIdentityRoute
      ? (await import("./App")).MobileIdentityValidationApp
      : (await import("./App")).CheckoutApp;

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Application />
    </React.StrictMode>,
  );
}

void mountApplication();
